export const Links = {
  MARKETING: 'https://www.pullrequest.com',
  FACEBOOK: 'https://www.facebook.com/pullrequestinc',
  GITHUB: 'https://github.com/pullrequestinc',
  TWITTER: 'https://twitter.com/pullrequestcom',
  LINKEDIN: 'https://www.linkedin.com/company/pullrequest',
  TERMS: 'https://www.pullrequest.com/terms/',
  PRIVACY_POLICY: 'https://www.pullrequest.com/privacy/',
  SECURITY_POLICY: 'https://www.pullrequest.com/security/',
};
